import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-width":"600px"} }
const _hoisted_2 = { class: "p-fluid p-grid p-col-12 p-formgrid" }
const _hoisted_3 = { class: "p-field p-col-12" }
const _hoisted_4 = { class: "p-field p-col-12 p-md-6 p-field-btn" }
const _hoisted_5 = { class: "p-field p-col-12 p-md-6 p-field-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_textarea = _resolveComponent("p-textarea")!
  const _component_p_dialog = _resolveComponent("p-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.enable)
      ? (_openBlock(), _createBlock(_component_p_button, {
          key: 0,
          rounded: "",
          style: {"width":"48px"},
          icon: "pi pi-times-circle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.globalFeedBackStart()))
        }))
      : _createCommentVNode("", true),
    (_ctx.enable)
      ? (_openBlock(), _createBlock(_component_p_button, {
          key: 1,
          rounded: "",
          style: {"width":"48px"},
          icon: "pi pi-info-circle",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogFlag = true))
        }))
      : _createCommentVNode("", true),
    (_ctx.enable)
      ? (_openBlock(), _createBlock(_component_p_button, {
          key: 2,
          rounded: "",
          style: {"width":"48px"},
          icon: "pi pi-check-circle",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.globalFeedBackStart('APPROVE')))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_p_dialog, {
      modal: "",
      style: {"margin":"10px"},
      header: "Remarks",
      visible: _ctx.dialogFlag,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogFlag) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_p_textarea, {
                modelValue: _ctx.remarks,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.remarks) = $event)),
                modelModifiers: { trim: true },
                type: "text",
                placeholder: "Enter remarks"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_p_button, {
                label: "Cancel",
                icon: "pi pi-times-circle",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFlag = false)),
                class: "p-button"
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_p_button, {
                label: "Request Information",
                icon: "pi pi-check-circle",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.globalFeedBackStart('REQUEST'))),
                class: "p-button"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}